import { Container, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import GraphHeader from "../../graphs/GraphHeader";
import ImageGraph from "../../graphs/ImageGraph";
import MultipleCorrelation from "./MultipleCorrelation";

const ResponseListResult = ({ test }) => {
	const [responses, setResponses] = useState([{ type: "string", value: "Loading..." }]);

	useEffect(() => {
		console.log(`${test?.title} -> ${test?.id}`);

		let newArray = [];
		let index = 0;
		let isConsecutiveHeader = 1;

		function gridCount(response) {
			let res = response.value.length;
			let gc = 4;
			if (res >= 5) {
				gc = 2.4;
			}
			if (res === 1) {
				gc = 12;
			}

			return gc;
		}

		if (test?.responseList && Array.isArray(test?.responseList)) {
			for (const [myIndex, res] of test?.responseList.entries()) {
				if (res.type === "spacer") {
					newArray.push({ header: res.type, value: res.value, type: res.type });
					index++;
				}
				if (res.type === "image") {
					newArray[index].type = res.type;
					newArray[index].value = res.value;
					// index++;
				}
				if (res.type === "header") {
					let gc = gridCount(res);
					if (isConsecutiveHeader >= 2) {
						index++;
					}
					for (const headerValue of res.value) {
						newArray.push({ header: headerValue, gc });
					}
					isConsecutiveHeader++;
				}
				if (res.type === "string") {
					isConsecutiveHeader = 1;
					for (const stringValue of res.value) {
						// console.log({ headerAndStringIndex: index });
						let gc = gridCount(res);
						// console.log(newArray[index]);

						if (newArray[index]) {
							newArray[index].value = stringValue;
							newArray[index].type = res.type;
						} else {
							newArray.push({
								header: "",
								gc,
								value: stringValue,
								type: res.type,
							});
						}
						index++;
					}
				}
			}
			// console.log("RESPONSE LIST RESULT 1");
			// console.log({ newArray });
			setResponses(newArray);
		} else {
			// console.log("RESPONSE LIST RESULT 2");
			// const temp = test?.responseList;
			// console.log({ temp });
			setResponses(test?.responseList);
		}
	}, [test]);

	return (
		<div>
			<GraphHeader
				column={test?.column}
				dateTime={test?.dateTime}
				title={test?.title}
				analysisId={test?.id}
				key={`${test?.id}-${test?.title}`}
			/>
			{test.result === "Error" ? (
				<Grid
					container
					spacing={{ xs: 2, md: 3 }}
					columns={{ xs: 4, sm: 8, md: 12 }}
					sx={{ color: "#535353" }}>
					<Grid item xs={12}>
						<h3>{test?.message || "An error occured"}</h3>
					</Grid>
				</Grid>
			) : (
				<Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
					{test.title === "Multiple Correlation" ? (
						<MultipleCorrelation response={responses} />
					) : responses && responses.length > 0 ? (
						responses.map((res, index) => {
							if (test?.title === "Simple Correlation" && res?.type === "image" && !res?.value) {
								const temp = res?.value;
								console.log(`!res?.value -> ${!temp}`);
								console.log(`value -> ${temp}`);
							}
							return (
								<>
									{res?.type === "string" ? (
										<Grid item xs={res?.gc} sm={res?.gc} md={res?.gc} key={index}>
											{res?.header && <h4>{res?.header}</h4>}
											{res?.value && (
												<h3 style={{ fontWeight: "normal" }}>{convertString(res?.value)}</h3>
											)}
										</Grid>
									) : res?.type === "image" && res?.value && typeof res?.value === "string" ? (
										<>
											<Grid
												key={index}
												container
												spacing={2}
												direction="column"
												justifyContent="center"
												alignItems="center"
												style={{ mt: 10 }}>
												<Grid item>
													<h4>{res?.header}</h4>
												</Grid>
											</Grid>
											<ImageGraph url={res?.value} title="" column={res?.column} />
										</>
									) : (
										res?.type === "spacer" && (
											<Grid item xs={12} sm={12} md={12} key={index}>
												<div
													style={{
														height: 10 * Number(res?.value),
													}}
												/>
											</Grid>
										)
									)}
								</>
							);
						})
					) : (
						<></>
					)}
				</Grid>
			)}
		</div>
	);
};

export default ResponseListResult;

const convertString = (input) => {
	// Check if input is a number
	if (!isNaN(input)) {
		// Parse input to number and ensure it has a maximum of 4 decimal places
		const parsedNumber = parseFloat(input);
		// Round number to 4 decimal places
		const roundedNumber = Math.round(parsedNumber * 10000) / 10000;
		// Convert number to string
		return roundedNumber.toString();
	} else if (!isNaN(parseFloat(input))) {
		// If input is a string of numbers, convert it to a number
		const parsedNumber = parseFloat(input);
		// Round number to 4 decimal places
		const roundedNumber = Math.round(parsedNumber * 10000) / 10000;
		// Convert number to string
		return roundedNumber.toString();
	} else {
		// If input is not a number, return it unchanged
		return input;
	}
};

function getRandomColor() {
	// Generate random hexadecimal color code
	const color = "#" + Math.floor(Math.random() * 16777215).toString(16);
	return color;
}
